import { z } from 'zod';
// ---------------------------------------------------------------------------
// Booking the planned date of a visit (Domain 4 — Cockpit, REQ-VIS-015)
// ---------------------------------------------------------------------------
/**
 * Body of `PATCH /api/v1/visits/:visitId/schedule` — the planned date
 * (`Date_scheduled`, dbase-v1.2 [s.15]) of ONE patient visit.
 *
 * `date` is a CALENDAR DAY (`z.iso.date()`), not an instant: the column is
 * `date`, and the whole cockpit reasons in days (the day plan filters on an
 * exact day, REQ-VIS-002). Do NOT copy the `z.iso.datetime()` used by the
 * enrollment timestamps — those are instants, this is a day.
 *
 * `null` CLEARS the booking (a visit can go back to "not scheduled yet"), which
 * is why the field is nullable rather than optional: an omitted `date` and an
 * explicit `null` differ — the first is a 400, the second is a deliberate undo.
 */
export const ScheduleVisitRequestSchema = z.object({
    date: z.iso.date().nullable(),
    time: z
        .string()
        .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Godzina musi być w formacie GG:MM (HH:MM)')
        .nullable()
        .optional(),
});
//# sourceMappingURL=schedule-visit.schema.js.map